export const TICKET_TYPES = {
	COUNTERCLAIMS: "counterclaims",
	PROVISIONAL_RETENTIONS: "provisionalRetentions",
	DAMAGES: "damages",
	DEFECTS: "defects",
	PENALTIES: "penalties",
	CORRECTIONS_CREDIT: "correctionsCredit",
	CORRECTIONS_DEBIT: "correctionsDebit",
	CONTRACT_SECURITY: "contractSecurity",
	WARRANTY_BONDS: "warrantyBonds",
};

export const TICKET_TYPE_LABELS = {
	counterclaims: "Z-GF Gegenforderung (Allgemein)",
	provisionalRetentions: "Z-EB Vorl. Einbehalte",
	damages: "Z-SCH Schaden",
	defects: "Z-MA Mangel",
	penalties: "Z-VS Vertragsstrafe",
	correctionsCredit: "Z-K+ Korrekturen Gutschrift",
	correctionsDebit: "Z-K- Korrekturen Belastung",
	contractSecurity: "Z-VE Vertragserfüllungsbürgschaften",
	warrantyBonds: "Z-GB Gewährleistungsbürgschaften",
};

export const TICKET_TYPE_CODES = {
	counterclaims: "GF",
	provisionalRetentions: "EB",
	damages: "SCH",
	defects: "MA",
	penalties: "VS",
	correctionsCredit: "K+",
	correctionsDebit: "K-",
	contractSecurity: "VE",
	warrantyBonds: "GB",
};

export const TICKET_STATUS = {
	OPEN: "OPEN",
	IN_PROGRESS: "IN_PROGRESS",
	SIGNED_OFF: "SIGNED_OFF",
	CLOSED: "CLOSED",
};

export const TICKET_STATUS_LABELS = {
	OPEN: "Open",
	IN_PROGRESS: "In Progress",
	SIGNED_OFF: "Signed off",
	CLOSED: "Closed",
};

// Get dropdown options for ticket types
export const getTicketTypeOptions = (t) => {
	return Object.values(TICKET_TYPES).map((type) => ({
		value: type,
		label: t ? t(`tickets.type.${type}`) : TICKET_TYPE_LABELS[type],
	}));
};

// Get dropdown options for ticket status
export const getTicketStatusOptions = (t) => {
	return Object.values(TICKET_STATUS).map((status) => ({
		value: status,
		label: t ? t(`tickets.status.${status}`) : TICKET_STATUS_LABELS[status],
	}));
};
